import {Deserializable} from '../deserializable';
import {Staffs} from './staffs';


export  class Users implements Deserializable
{
  public  id: number;
  public  staffID: number;
  public  userName: string;
  public  password: string;
  public  staffItem: Staffs;
  public  roleName: string;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.staffItem = input.staffsItem!=null? new Staffs().deserialize(input.staffsItem): null;
    return this;
  }
}
